import type { ReactNode } from "react"
import { Toaster } from "@/components/ui/sonner"
import { ThemeProvider } from "@/providers/theme-provider"

export const LandingLayout = ({ children }: { children: ReactNode }) => (
  <ThemeProvider defaultTheme="system" storageKey="landing-ui-theme">
    <Toaster position="top-center" richColors />
    {children}
  </ThemeProvider>
)
